
import React, { useState, useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import Tabs from "./Tabs";
import Summary from "./Summary";
import { Box } from "@mui/material";
import ErrorDetails from "./ErrorDetails";
import RuleCatalogue from "./RuleCatalogue";
import axios from "axios";
import "./DataProduct.css";
import { DASHBOARD_VIEW_NAME } from "../../constants/Dashboard"


const DataProduct = () => {
  const { productId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const [dashboardId, setDashboardId] = useState(null);
  const tabFromUrl = searchParams.get("tab") || "Summary";
  const [activeTab, setActiveTab] = useState(tabFromUrl);
  const [prevTab, setPrevTab] = useState(activeTab);
  const [activePeriod, setActivePeriod] = useState("Current");

  const [filters, setFilters] = useState({});
  const [searchTerms, setSearchTerms] = useState({
    Summary: "",
    "Error Details": "",
    "Rule Catalogue": "",
  });
  const [pivotGrouping, setPivotGrouping] = useState({});
  const [toast, setToast] = useState({ message: "", type: "" });

  const handleSearchChange = (tab, value) => {
    setSearchTerms(prev => ({ ...prev, [tab]: value }));
  };

  const handlePeriodChange = (period) => {
    if (period === "current") setActivePeriod("Current");
    else if (period === "last") setActivePeriod("Previous");
  };

  const handleSaveFilters = async () => {
    const BASE_URL = process.env.REACT_APP_API_URL;

    const payload = {
      product_id: productId,
      filters: filters,
      search_term: searchTerms[activeTab],
      pivot_grouping: pivotGrouping,
      dashboard_view_name: DASHBOARD_VIEW_NAME,
      period: activePeriod,
    };

    try {
      const res = await axios.post(`${BASE_URL}/save-dashboard-view`, payload);
      if (res.data?.dashboard_id) {
        setDashboardId(res.data.dashboard_id);
      }


      if (res.data?.message) {
        setToast({ message: res.data.message, type: "success" });
      } else {
        setToast({ message: "Filters saved successfully", type: "success" });
      }

      setTimeout(() => setToast({ message: "", type: "" }), 2500);
    } catch (error) {
      if (error.response?.status === 409) {
        setToast({ message: error.response.data.detail, type: "warning" });
      } else {
        setToast({ message: "Please apply a filter before saving", type: "error" });
      }

      setTimeout(() => setToast({ message: "", type: "" }), 2500);
    }
  };



  const handleFiltersChange = (newFilters) => {
    if (newFilters.pivot_grouping) {
      setPivotGrouping(newFilters.pivot_grouping);
      return;
    }

    if (!newFilters || Object.keys(newFilters).length === 0) {
      setFilters({});
      return;
    }

    const formatted = {};
    Object.entries(newFilters).forEach(([key, val]) => {
      const cap = key.charAt(0).toUpperCase() + key.slice(1);
      formatted[cap] = val;
    });

    setFilters(formatted);
  };



  useEffect(() => {
    const params = new URLSearchParams(searchParams);
    params.set("tab", activeTab);
    setSearchParams(params);
  }, [activeTab, searchParams, setSearchParams]);

  useEffect(() => {
    setSearchTerms(prev => ({
      ...prev,
      [prevTab]: ""
    }));

    setPrevTab(activeTab);
  }, [activeTab]);


  return (
    <Box
      sx={{
        padding: 0,

      }}
    >
      <div className="dashboard-dashboard poppins-regular">
        {toast.message && (
          <div
            style={{
              position: "fixed",
              top: "80px",
              left: "50%",
              transform: "translateX(-50%)",
              background:
                toast.type === "success"
                  ? "#4caf50"
                  : toast.type === "warning"
                    ? "#ff9800"
                    : "#f44336",
              color: "#fff",
              padding: "6px 14px",
              borderRadius: "6px",
              fontSize: "14px",
              fontWeight: "500",
              zIndex: 1000,
            }}
          >
            {toast.message}
          </div>
        )}

        <Tabs activeTab={activeTab} setActiveTab={setActiveTab} onSaveClick={handleSaveFilters} dashboardId={dashboardId} />

        <div className="tab-content-tab" style={{ background: '#F7F7F7', padding: '28px' }}>
          {activeTab === "Summary" && <Summary
            productId={productId}
            currentFilters={filters}
            onFiltersChange={handleFiltersChange}
            searchTerm={searchTerms.Summary}
            activePeriod={activePeriod}
            onPeriodChange={handlePeriodChange}
          />}

          {activeTab === "Error Details" && (

            <ErrorDetails
              productId={productId}
              currentFilters={filters}
              onFiltersChange={handleFiltersChange}
              searchTerm={searchTerms["Error Details"]}
              onSearchChange={(value) => handleSearchChange("Error Details", value)}
            />
          )}

          {activeTab === "Rule Catalogue" && (
            <RuleCatalogue
              productId={productId}
              currentFilters={filters}
              onFiltersChange={handleFiltersChange}
              searchTerm={searchTerms["Rule Catalogue"]}
              onSearchChange={(value) => handleSearchChange("Rule Catalogue", value)}
            />
          )}
        </div>
      </div>
    </Box>
  );
};

export default DataProduct;


